const subscription_variations = {
  init: () => {
    subscription_variations.events();
    subscription_variations.toggleSubscriptionUpdate();
  },

  events: () => {
    $(document).on('submit', '.product-form__subscription-variations', function (e) {
      subscription_variations.addToBasket(e, this);
    });

    // Handle variation card clicks
    $(document).on('click tap', '.product-form__subscription-variations .variation-card', function (e) {
      e.preventDefault();
      subscription_variations.selectVariantCard(this);
    });

    // Handle keyboard navigation for variation cards
    $(document).on('keydown', '.product-form__subscription-variations .variation-card', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        subscription_variations.selectVariantCard(this);
      }
    });

    $(document).on('click tap', '.product-form__subscription-variations .quantity button', function (e) {
      e.preventDefault();
      subscription_variations.updateClosestNumberInput(this, $(this).hasClass('plus')); t
      subscription_variations.toggleSubscriptionUpdate();
    });

    $(document).on('change', '.product-form__subscription-variations select[name="subscription-plans"]', function () {
      subscription_variations.toggleSubscriptionUpdate();
    });

    $(document).on(
      'change',
      '.product-form__subscription-variations .subscription-toggles input[type="radio"]',
      function () {
        subscription_variations.updateSubscriptionOption(this);
      },
    );

    $(document).on('click', '#cart-link', function (e) {
      e.preventDefault();
      subscription_variations.triggerCartDrawer();
    });
  },

  triggerCartDrawer: () => {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.querySelector('cart-drawer').show();
  },

  selectVariantCard: (card) => {
    const form = card.closest('.product-form__subscription-variations');
    const variantId = card.getAttribute('data-variant-id');
    const variantPrice = card.getAttribute('data-variant-price');

    // Remove active class from all cards
    form.querySelectorAll('.variation-card').forEach((c) => c.classList.remove('active'));

    // Add active class to clicked card
    card.classList.add('active');

    // Update hidden input with selected variant ID
    const hiddenInput = form.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = variantId;
    }

    // Update price display
    subscription_variations.toggleSubscriptionUpdate();
  },

  checkQuantity: (total_quantity = null) => {
    const form = document.querySelector('.product-form__subscription-variations');
    if (!form) return;

    const addToCartBtn = form.querySelector('button.add-to-cart');
    if (!addToCartBtn) return;

    // Check if we have card-based selection
    const activeCard = form.querySelector('.variation-card.active');

    if (activeCard) {
      // Card-based selection - if a card is active, we have a valid selection
      addToCartBtn.classList.remove('disabled');
    } else {
      // Legacy quantity-based check
      if (!total_quantity) {
        total_quantity = 0;
        document.querySelectorAll('input[name="quantity"].subscription_variations').forEach((quantity) => {
          total_quantity = total_quantity + parseInt(quantity.value, 10);
        });
      }

      if (total_quantity > 0) {
        addToCartBtn.classList.remove('disabled');
      } else {
        addToCartBtn.classList.add('disabled');
      }
    }
  },

  closest: (el, sel) => {
    if (el != null)
      return el.matches(sel) ? el : el.querySelector(sel) || subscription_variations.closest(el.parentNode, sel);
  },

  updateClosestNumberInput: (el, increment = true) => {
    var value = parseInt(subscription_variations.closest(el, 'input[type="number"]').value, 10);
    value = isNaN(value) ? 0 : value;
    increment ? value++ : value--;
    subscription_variations.closest(el, 'input[type="number"]').value = value < 0 ? 0 : value;
  },

  updateSubscriptionOption: (el) => {
    console.log('updateSubscriptionOption');
    // Update toggle container selected state
    const form = el.closest('.product-form__subscription-variations');
    if (form) {
      form.querySelectorAll('.toggle-container').forEach((container) => container.classList.remove('selected'));
      const closestContainer = el.closest('.toggle-container');
      if (closestContainer) {
        closestContainer.classList.add('selected');
      }
    }
    subscription_variations.calculatePricePerServing();
  },

  addToBasket: (event, form) => {
    event.preventDefault();

    form.classList.add('loading');

    let items = [];

    // Check for new card-based variant selection
    const activeCard = form.querySelector('.variation-card.active');

    if (activeCard) {
      // New card-based selection - single variant
      const variantId = parseInt(activeCard.getAttribute('data-variant-id'), 10);

      var item = {
        id: variantId,
        quantity: 1,
      };

      const subscribeRadio = form.querySelector('input[name="subscription-toggle"]#subscribe');
      if (subscribeRadio && subscribeRadio.checked) {
        console.log('Subscription selected for variant ID:', variantId);
        const selectedPlan = form.querySelector('select[name="subscription-plans"]').value;
        item['selling_plan'] = selectedPlan;
      }

      items.push(item);
    } else {
      // Legacy quantity-based selection (fallback)
      document.querySelectorAll('input[name="quantity"].subscription_variations').forEach((quantity) => {
        if (quantity.value > 0) {
          var item = {
            id: parseInt(quantity.dataset.id, 10),
            quantity: parseInt(quantity.value, 10),
          };

          if (document.querySelector('input[name="subscription-toggle"]#subscribe').checked) {
            const subscribeRadio = form.querySelector('input[name="subscription-toggle"]#subscribe');
            if (subscribeRadio && subscribeRadio.checked) {
              console.log('Subscription selected for variant ID:', variantId);
              const selectedPlan = form.querySelector('select[name="subscription-plans"]').value;
              item['selling_plan'] = selectedPlan;
            }
          }

          items.push(item);
        }
      });
    }

    let formData = {
      items: items,
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log('response', response);
        //window.location.href = window.Shopify.routes.root + 'cart';
        subscription_variations.triggerCartDrawer();
        form.classList.remove('loading');
        return;
      })
      .catch((error) => {
        form.classList.remove('loading');
        console.error('Error:', error);
      });

    return false;
  },

  toggleSubscriptionUpdate: () => {
    console.log('toggleSubscriptionUpdate');
    // Check for new card-based variant selection
    const form = document.querySelector('.product-form__subscription-variations');
    if (!form) return;

    const activeCard = form.querySelector('.variation-card.active');
    let total_price = 0;
    let total_quantity = 0;

    if (activeCard) {
      // New card-based selection
      total_price = parseInt(activeCard.getAttribute('data-variant-price'), 10) * 0.01;
      total_quantity = 1;
    } else {
      // Legacy quantity-based selection (fallback)
      document.querySelectorAll('input[name="quantity"].subscription_variations').forEach((quantity) => {
        total_quantity = total_quantity + parseInt(quantity.value, 10);
        total_price = total_price + parseInt(quantity.dataset.value, 10) * parseInt(quantity.value, 10);
      });
      total_price = total_price * 0.01;
    }

    subscription_variations.checkQuantity(total_quantity);

    document.querySelectorAll('.subscription_variations-price').forEach((price) => {
      price.innerHTML = price.dataset.symbol + total_price.toFixed(2);
    });

    let price = total_price;

    var multiplier = 1;

    if (total_price > 0) {
      var el = document.querySelector('.product-form__subscription-variations select[name="subscription-plans"]');
      if (el && el.options[el.selectedIndex]) {
        multiplier = multiplier - el.options[el.selectedIndex].dataset.discount / 100;
      }

      price = (total_price * multiplier).toFixed(2);
      document.querySelectorAll('.subscription_variations-sub-price').forEach((sub_price) => {
        sub_price.innerHTML = sub_price.dataset.symbol + price;
      });

      const savings = (total_price - parseFloat(price)).toFixed(2);
      document.querySelectorAll('.subscription-savings-badge').forEach((badge) => {
        badge.innerHTML = 'Save ' + badge.dataset.symbol + savings;
      });
    } else {
      document.querySelectorAll('.subscription_variations-sub-price').forEach((price) => {
        price.innerHTML = '';
      });
      document.querySelectorAll('.subscription-savings-badge').forEach((badge) => {
        badge.innerHTML = '';
      });
    }

    $('input[name="subscription-toggle"]#subscribe').data('price', price);
    $('input[name="subscription-toggle"]#one-time').data('price', total_price.toFixed(2));

    subscription_variations.calculatePricePerServing(multiplier);
  },

  calculatePricePerServing: () => {
    $('.variation-card__price-per-serving').each(function () {
      const subscriptionActive = $('input[name="subscription-toggle"]:checked').val() === 'subscribe';
      console.log('subscriptionActive', subscriptionActive);
      const discountPercentage = $('select[name="subscription-plans"]').find('option:selected').data('discount');
      const discount = subscriptionActive ? 1 - (parseFloat(discountPercentage) / 100) : 1;
      const pricePerServing = parseFloat(this.dataset.pricePerServing / 100) * discount;
      this.innerHTML = this.dataset.symbol + pricePerServing.toFixed(2) + '/serving';
    });
  },
};

const variant_selector_block = {
  init: () => {
    variant_selector_block.events();
    variant_selector_block.toggleSubscriptionUpdate();
  },

  events: () => {
    $(document).on('submit', '.product-form__variant-selector-block', function (e) {
      variant_selector_block.addToBasket(e, this);
    });

    $(document).on('click tap', '.product-form__variant-selector-block .quantity button', function (e) {
      e.preventDefault();
      variant_selector_block.updateClosestNumberInput(this, $(this).hasClass('plus'));
      variant_selector_block.toggleSubscriptionUpdate();
    });

    $(document).on('change', '.product-form__variant-selector-block select[name="subscription-plans"]', function () {
      variant_selector_block.toggleSubscriptionUpdate();
    });

    $(document).on(
      'change',
      '.product-form__variant-selector-block .subscription-toggles input[type="radio"]',
      function () {
        variant_selector_block.updateSubscriptionOption(this);
      },
    );
  },

  checkQuantity: (total_quantity = null) => {
    if (!total_quantity) {
      document
        .querySelectorAll('input[name="quantity"].variant_selector_block')
        .forEach((quantity) => (total_quantity = total_quantity + parseInt(quantity.value, 10)));
    }

    const addToCartBtn = document.querySelector('.product-form__variant-selector-block button.add-to-cart');
    if (addToCartBtn) {
      if (total_quantity > 0) {
        addToCartBtn.classList.remove('disabled');
      } else {
        addToCartBtn.classList.add('disabled');
      }
    }
  },

  closest: (el, sel) => {
    if (el != null)
      return el.matches(sel) ? el : el.querySelector(sel) || variant_selector_block.closest(el.parentNode, sel);
  },

  updateClosestNumberInput: (el, increment = true) => {
    var value = parseInt(variant_selector_block.closest(el, 'input[type="number"]').value, 10);
    value = isNaN(value) ? 0 : value;
    increment ? value++ : value--;
    variant_selector_block.closest(el, 'input[type="number"]').value = value < 0 ? 0 : value;
  },

  updateSubscriptionOption: (el) => {
    const container = el.closest('.product-form__variant-selector-block');
    if (container) {
      container.querySelectorAll('.toggle').forEach((toggle) => toggle.classList.remove(' selected'));
      const closestToggle = el.closest('.toggle');
      if (closestToggle) {
        closestToggle.classList.add(' selected');
      }
    }
  },

  addToBasket: (event, form) => {
    event.preventDefault();

    form.classList.add('loading');

    let items = [];

    document.querySelectorAll('input[name="quantity"].variant_selector_block').forEach((quantity) => {
      if (quantity.value > 0) {
        var item = {
          id: parseInt(quantity.dataset.id, 10),
          quantity: parseInt(quantity.value, 10),
        };

        const subscribeRadio = form.querySelector('input[name="subscription-toggle"]#subscribe-variant');
        if (subscribeRadio && subscribeRadio.checked) {
          //subscribe is checked, add in sales rules
          const planTitle = form.querySelector('select[name="subscription-plans"]').value;
          const plansForQuantity = document.querySelectorAll('input[name="variation-' + quantity.dataset.id + '"]');

          var planId = 0;
          plansForQuantity.forEach((plan) => {
            if (plan.dataset.plantitle == planTitle) {
              planId = plan.value;
            }
          });

          if (planId && planId > 0) {
            item['selling_plan'] = planId;
          }
        }

        items.push(item);
      }
    });

    let formData = {
      items: items,
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        window.location.href = window.Shopify.routes.root + 'cart';
        return response.json();
      })
      .catch((error) => {
        form.classList.remove('loading');
        console.error('Error:', error);
      });

    return false;
  },

  toggleSubscriptionUpdate: () => {
    var total_quantity = 0;
    document
      .querySelectorAll('input[name="quantity"].variant_selector_block')
      .forEach((quantity) => (total_quantity = total_quantity + parseInt(quantity.value, 10)));

    variant_selector_block.checkQuantity(total_quantity);

    var total_price = 0;
    document
      .querySelectorAll('input[name="quantity"].variant_selector_block')
      .forEach(
        (quantity) => (total_price = total_price + parseInt(quantity.dataset.value, 10) * parseInt(quantity.value, 10)),
      );

    total_price = total_price * 0.01;

    document
      .querySelectorAll('.variant_selector_block-price')
      .forEach((price) => (price.innerHTML = price.dataset.symbol + total_price.toFixed(2)));

    if (total_price > 0) {
      var multiplier = 1;
      var el = document.querySelector('.product-form__variant-selector-block select[name="subscription-plans"]');
      if (el) {
        multiplier = multiplier - el.options[el.selectedIndex].dataset.discount / 100;
        document
          .querySelectorAll('.variant_selector_block-sub-price')
          .forEach(
            (sub_price) => (sub_price.innerHTML = sub_price.dataset.symbol + (total_price * multiplier).toFixed(2)),
          );
      }
    } else {
      document.querySelectorAll('.variant_selector_block-sub-price').forEach((price) => (price.innerHTML = ''));
    }
  },
};

const theme = {
  init: () => {
    theme.events();

    if ($('.accordianify').length) {
      $('.accordianify').each(function () {
        theme.accordian($(this));
      });
    }
  },
  events: () => {
    if ($('.product-links').length) {
      $(document).on('click tap', '.product-links .popup-link', function (e) {
        e.preventDefault();
        const handle = $(this).data('popup');
        $('.product-links-overlay').addClass('show');
        $('.product-links-popup[data-popup="' + handle + '"]').addClass('show');
      });

      $(document).on('click tap', '.product-links-overlay, .product-links-popup .close', function (e) {
        e.preventDefault();
        $('.product-links-overlay').removeClass('show');
        $('.product-links-popup').removeClass('show');
      });
    }

    $(document).on('click', '.menu-toggle', function (e) {
      e.preventDefault();
      $('nav').toggleClass('open');
    });

    $(document).on('click', '.mobile-overlay', function (e) {
      e.preventDefault();
      if ($('nav').hasClass('open')) $('nav').removeClass('open');
    });

    $(document).on('click', '.mobile-navigation li.has-children > a', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('open');
    });
  },
  accordian: (element) => {
    $(element)
      .find('h3')
      .each(function () {
        $(this).on('click tap', function () {
          $(this).toggleClass('active');
          $(this).next().toggleClass('active');
        });
      });
  },
};

jQuery(() => {
  theme.init();

  const initComponents = () => {
    if ($('.product-form__subscription-variations').length && !$('.product-form__subscription-variations').data('init')) {
      $('.product-form__subscription-variations').data('init', true);
      subscription_variations.init();
    }
    if ($('.product-form__variant-selector-block').length && !$('.product-form__variant-selector-block').data('init')) {
      $('.product-form__variant-selector-block').data('init', true);
      variant_selector_block.init();
    }
  };

  initComponents();

  const observer = new MutationObserver(initComponents);
  observer.observe(document.body, { childList: true, subtree: true });
});